import PurchaseRoom from "../../components/Rooms/PurchaseRoom";

const SetupRoom = (props: any) => {
    return <PurchaseRoom />;
  };
  
  export default SetupRoom;